import { NAME as name } from './constants';
import { router } from './router';

export const NastaveniUpozornovani = {
	name,
	router,
};
